import {Ventrata} from 'types'

export const getOrderUnitCounterMap = (order: Ventrata.Order) => {
  const counterMap = {
    ADULT: 0,
    CHILD: 0,
    INFANT: 0,
  }

  for (const booking of order.bookings) {
    for (const unitItem of booking.unitItems) {
      counterMap[unitItem.unit.type]++
    }
  }

  return counterMap
}
